module.exports = __webpack_public_path__ + "img/menu.2c059742.jpg";